import React from 'react';
import { Grid, Typography } from '@mui/material';
import India from '../../assets/Icons/India';
import Confirmed from '../../assets/Icons/Confirmed';
import loginFooterStyles from './LoginFooter.styles';
import { useTranslation } from '../../hooks/useTranslation';

const LoginFooter = () => {
	const { t } = useTranslation();
	return (
		<Grid
			container
			flexDirection={'column'}
			sx={{
				width: '100%',
				left: '0',
				bottom: '60px',
				borderRadius: '8px',
				overflow: 'hidden',
			}}
		>
			{!global.disableTrustFooter && <Grid item>
				<Grid
					container
					sx={{ ...loginFooterStyles.gridContainer1, textAlign: 'left' }}
				>
					<Grid item sx={{ lineHeight: '0.5rem', ...loginFooterStyles.icon }}>
						<India />
					</Grid>

					<Grid item xs>
						<Typography>{t('login.footer.usedByMillions')}</Typography>
					</Grid>
				</Grid>
			</Grid>
            }

			<Grid item>
				<Grid
					container
					sx={{ ...loginFooterStyles.gridContainer2, textAlign: 'left' }}
				>
					<Grid item sx={{ lineHeight: '0.5rem', ...loginFooterStyles.icon }}>
						<Confirmed />
					</Grid>

					<Grid item xs>
						<Typography>{t('login.footer.secureQuickSharing')}</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default LoginFooter;
